import React, { ReactNode } from 'react'
import { AmplitudeContext } from './context'
import { useLocalStorage } from '../../hooks'
import amplitude from 'amplitude-js'

interface Props {
  children: ReactNode
}

export function AmplitudeProvider({ children }: Props) {
  const [storage, setStorage] = useLocalStorage('amplitude')

  const incrementCounter = (name: string) => {
    return () => {
      const count = storage && storage[name] ? storage[name] + 1 : 1
      setStorage({
        ...storage,
        [name]: count,
      })
      amplitude.getInstance().setUserProperties({ [name]: count })
    }
  }

  const incrementSwapCount = incrementCounter('swapCount')
  const incrementDepositCount = incrementCounter('depositCount')
  const incrementWithdrawCount = incrementCounter('withdrawCount')

  return (
    <AmplitudeContext.Provider
      value={{ incrementSwapCount, incrementDepositCount, incrementWithdrawCount }}
      children={children}
    />
  )
}
